import React from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  transKey: string;
  params?: { [key: string]: string | number | JSX.Element };
}

export const Translate: React.FunctionComponent<Props> = ({
  transKey,
  params,
}) => <FormattedMessage id={transKey} values={params} />;
